import { render, staticRenderFns } from "./raskDetailMany.vue?vue&type=template&id=a22faaae&scoped=true&"
import script from "./raskDetailMany.vue?vue&type=script&lang=js&"
export * from "./raskDetailMany.vue?vue&type=script&lang=js&"
import style0 from "./raskDetailMany.vue?vue&type=style&index=0&id=a22faaae&scoped=true&lang=less&"
import style1 from "./raskDetailMany.vue?vue&type=style&index=1&id=a22faaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22faaae",
  null
  
)

export default component.exports